module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (true),
      expression: "true"
    }],
    staticClass: "company-client",
    staticStyle: {
      "height": "100%"
    }
  }, [_c('h4', {
    staticClass: "alert alert-warning text-center",
    staticStyle: {
      "margin-top": "0px"
    }
  }, [_c('span', {
    staticClass: "pre",
    domProps: {
      "textContent": _vm._s(_vm.companyClient.messageTextPre)
    }
  }), _vm._v(" "), _c('strong', {
    staticClass: "short",
    domProps: {
      "textContent": _vm._s(_vm.companyClient.messageTextShort)
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "post",
    domProps: {
      "textContent": _vm._s(_vm.companyClientMessageTextPost)
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "border-bottom": "1px solid #CCC"
    }
  }, [_c('h2', [_c('i', {
    staticClass: "fa fa-industry ",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(_vm._s(_vm.companyClient.name) + " - "), _c('small', [_vm._v(_vm._s(_vm.companyClient.street) + " " + _vm._s(_vm.companyClient.streetNumber) + ", " + _vm._s(_vm.companyClient.zipCode) + " " + _vm._s(_vm.companyClient.city) + " (" + _vm._s(_vm.calledNumber) + ")")])])]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "height": "calc(100% - 120px)"
    }
  }, [_c('div', {
    staticClass: "col-xs-8",
    staticStyle: {
      "border-right": "1px solid #CCC",
      "height": "100%"
    }
  }, [_c('div', {
    staticClass: "cc-memo-list"
  }, [_c('div', {
    staticClass: "panel-group",
    attrs: {
      "id": "company-client-memo-accordion",
      "role": "tablist",
      "aria-multiselectable": "true"
    }
  }, _vm._l((_vm.memos), function(memo, index) {
    return _c('cc-memo', {
      key: memo.id,
      staticClass: "panel cc-panel-default cc-memo-item",
      attrs: {
        "collapseIn": _vm.isMemoCollapse(index),
        "data_parent": 'company-client-memo-accordion',
        "memo": memo
      },
      on: {
        "remove": _vm.onRemoveMemo,
        "update": _vm.onSetMemo
      }
    })
  }), 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.memos.length),
      expression: "!memos.length"
    }],
    staticClass: "alert alert-warning",
    attrs: {
      "role": "alert"
    }
  }, [_vm._v("Keine Vorgaben")]), _vm._v(" "), (_vm.companyClient.id > 0) ? _c('cc-memo', {
    staticClass: "cc-kombox-item",
    attrs: {
      "idCompany": _vm.companyClient.id,
      "idUser": 0
    },
    on: {
      "insert": _vm.onAddMemo
    }
  }) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-4",
    staticStyle: {
      "height": "100%"
    }
  }, [_c('div', {
    staticClass: "cc-kombox-list"
  }, [_vm._l((_vm.komboxes), function(kombox) {
    return _c('cc-kombox', {
      key: kombox.id,
      staticClass: "cc-kombox-item",
      attrs: {
        "kombox": kombox
      },
      on: {
        "add-shipping": _vm.onKomboxAddShipping,
        "remove-shipping": _vm.onKomboxRemoveShipping,
        "remove": _vm.onRemoveKombox,
        "update": _vm.onSetKombox
      }
    })
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.komboxes.length),
      expression: "!komboxes.length"
    }],
    staticClass: "alert alert-warning",
    attrs: {
      "role": "alert"
    }
  }, [_vm._v("Keine Komboxen")]), _vm._v(" "), (_vm.companyClient.id > 0) ? _c('cc-kombox', {
    staticClass: "cc-kombox-item",
    attrs: {
      "idCompany": _vm.companyClient.id,
      "idUser": 0
    },
    on: {
      "insert": _vm.onAddKombox
    }
  }) : _vm._e()], 2)])])]), _vm._v(" "), (_vm.startModal) ? _c('company-client-start-modal', {
    on: {
      "close": _vm.hideStartModal,
      "abort": _vm.abortStartModal
    }
  }, [_c('div', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('h1', {
    staticClass: "alert alert-warning text-center",
    staticStyle: {
      "margin-top": "0px"
    }
  }, [_c('span', {
    staticClass: "pre",
    domProps: {
      "textContent": _vm._s(_vm.companyClient.messageTextPre)
    }
  }), _vm._v(" "), _c('strong', {
    staticClass: "short",
    domProps: {
      "textContent": _vm._s(_vm.companyClient.messageTextShort)
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "post",
    domProps: {
      "textContent": _vm._s(_vm.companyClientMessageTextPost)
    }
  })])])]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5c95ae55!./~/vue-loader/lib/selector.js?type=template&index=0!./src/CompanyClient.vue
// module id = 278
// module chunks = 0